import { supabase } from "./supabase";

// findKitchenHomeForCanonical — answer "where does this household
// already keep this canonical?" The user's existing pantry_items
// rows are the strongest signal we have for placement on a re-scan
// of the same canonical. If you keep gochugaru in spices_condiments,
// the next gochugaru scan should land in spices_condiments by
// default — not at whatever the canonical's bundled metadata
// claims, and not at a tag-hint guess from the OFF category list.
//
// This is a resolver tier between UPC corrections (taught for THIS
// upc) and canonical metadata (taught for any user, anywhere). It
// lets the user retag once and have every future scan respect the
// retag without admin promotion or editing canonical metadata.
//
// RLS scope: SELECT on pantry_items is family-scoped. The query
// returns rows the calling user can see, which is exactly the
// household we want to read from. No explicit filter needed.
//
// Result: { location, tileId, brand, state, cut } | null. The most
// recently-touched row's placement wins — if the user moved
// gochugaru from "international" to "korean_spices" yesterday, that
// move is reflected in this read.

export async function findKitchenHomeForCanonical(canonicalId) {
  if (!canonicalId) return null;
  const { data, error } = await supabase
    .from("pantry_items")
    .select("location, tile_id, brand, state, cut, updated_at")
    .eq("canonical_id", canonicalId)
    .order("updated_at", { ascending: false })
    .limit(1);
  if (error) {
    console.warn("[kitchen-home] read failed:", error.message);
    return null;
  }
  if (!Array.isArray(data) || data.length === 0) return null;
  const row = data[0];
  // "misc" is the catchall sentinel every location registry exports
  // as a final fallback — surfacing it as a teaching signal feeds
  // the broken placement back into every future scan. Strip on
  // read so downstream tiers (tag-hints → canonical-info) can
  // resolve the canonical's hub-chain default instead.
  const tileId = row.tile_id === "misc" ? null : (row.tile_id || null);
  return {
    location: row.location || null,
    tileId,
    brand:    row.brand    || null,
    state:    row.state    || null,
    cut:      row.cut      || null,
  };
}
